module.exports = __webpack_public_path__ + "static/media/PB_G_04.1aca8641.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/green/PB_G_04.png
// module id = 217
// module chunks = 0